import { css } from '@emotion/react';
import { Paper } from '@mui/material';
import { Redirect, Route, Switch } from 'react-router-dom';

import { RouteLayout } from 'shared/components/layouts';
import { ROUTES } from 'shared/constants';
import { useFeatureEnabled } from 'shared/hooks';

import { MemberInformationSidebar } from '../components';
import { MemberDetailsPage } from './MemberDetailsPage';
import { MemberMembershipsPage } from './MemberMembershipsPage';
import { MemberRewardAccountPage } from './MemberRewardAccountPage';

const contentCss = css`
  display: grid;
  grid-template-columns: 1fr 4fr;
  min-height: 85vh;
`;

export function MemberDetailsRouter() {
  const { enabled: showRewardingAccount } = useFeatureEnabled('rewardActions');
  const { enabled: showMemberships } = useFeatureEnabled('communityMarketplace');

  return (
    <RouteLayout
      content={
        <Paper css={contentCss} elevation={1} square={false} variant="elevation">
          <MemberInformationSidebar />

          <Switch>
            <Route path={ROUTES.admin.members.memberInformation}>
              <MemberDetailsPage />
            </Route>

            {showRewardingAccount && (
              <Route path={ROUTES.admin.members.memberRewardAccount}>
                <MemberRewardAccountPage />
              </Route>
            )}

            {showMemberships && (
              <Route path={ROUTES.admin.members.memberMemberships}>
                <MemberMembershipsPage />
              </Route>
            )}

            <Redirect to={ROUTES.admin.members.index} />
          </Switch>
        </Paper>
      }
    />
  );
}
